// extracted by mini-css-extract-plugin
export default {"tree_select":"treeSelectProblems_tree_select__4W2YO"};